import { FusionSectionGrid } from '../FusionSection';
import { Product } from '@benzinga/content-manager';
import { FusionServiceCard } from './index';

export interface FusionServiceCardsProps {
  products: Product[];
  withScroll: boolean;
  columns: {
    lg: number;
    md: number;
    sm?: number;
    xs?: number;
  };
}

const FusionServiceCards = ({ columns, products, withScroll }: FusionServiceCardsProps) => {
  return (
    <FusionSectionGrid columns={columns} mobileScroll={withScroll}>
      {products?.map((card, i) => <FusionServiceCard key={i} {...card} />)}
    </FusionSectionGrid>
  );
};

FusionServiceCards.defaultProps = {
  columns: {
    lg: 3,
    md: 2,
    sm: 2,
    xs: 1,
  },
  withScroll: true,
};

export default FusionServiceCards;
